export default "__VITE_ASSET__D4$URyD0__"